// @module TavanoTeam.CSExtensions.CSCertCaptureExt.CertPDF.View
define('TavanoTeam.CSExtensions.CSCertCaptureExt.CertPDF.View'
,	[
        'GlobalViews.Confirmation.View'
        
    ,   'tavanoteam_csextensions_cscertcaptureext_certpdf.tpl'

	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
        GlobalViewsConfirmationView

	,   tavanoteam_csextensions_cscertcaptureext_certpdf_tpl

	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class TavanoTeam.CSExtensions.CSCertCaptureExt.CertPDF.View @extends Backbone.View
	return Backbone.View.extend({

        template: tavanoteam_csextensions_cscertcaptureext_certpdf_tpl

    ,   initialize: function(options)
        {
            this.pdf = options.encodedPDFStr;
        }

		//@method getContext @return TavanoTeam.CSExtensions.CSCertCaptureExt.CertPDF.View.Context
	,   getContext: function getContext()
		{
			//@class TavanoTeam.CSExtensions.CSCertCaptureExt.CertPDF.View.Context
			return {
                pdfFile: this.pdf
			};
		}
	});
});
